import { GriddedItem, GridLayout, GridState } from "./grid";

export default function fixedGridder(items: HTMLElement[], state: GridState): GridLayout {
  let itemList: GriddedItem[] = [];
	let columnCount = state.gridColumns || 4;
	let marginX = state.gridSpacingXPx || 0;
  let marginY = state.gridSpacingYPx || 0;
  let combinedXMargins = marginX * (columnCount-1);
  let itemCount = items.length;

  let widthHeightRatio = state.widthHeightRatio || 16/9;
  let columnWidth = (state.containerWidth - combinedXMargins) / columnCount;
  let columnHeight = columnWidth / widthHeightRatio;

  let rowCount = Math.floor((itemCount-1)/columnCount)+1;
  let height = rowCount * (columnHeight + marginY) - marginY;
  
  for (let i=0; i<items.length; i++) {
    let item = items[i];
    let column = i % columnCount;
    let row = Math.floor(i / columnCount);
    itemList.push({
      DOM: item,
      css: {
        top: row * columnHeight + row * marginY,
        left: column * columnWidth + column * marginX,
        width: columnWidth,
        height: columnHeight
      }
    });
    column = (column + 1) % columnCount;
  }

  return {
    itemList: itemList,
    height: height
  }
};
